import { mixpanel } from 'utils';
class AnalyticsManager {
    logEvent = (eventName: string, payload: object) => {
        return mixpanel.track(eventName, payload);
    };
}
const analyticsManager = new AnalyticsManager();
export default analyticsManager;
